// removed by extract-text-webpack-plugin
module.exports = {"navLinks":"_2sEVH","navLink":"_2-G97","isActive":"_1nrll"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/NavLinks.scss
// module id = 1393
// module chunks = 0